import React, { useEffect } from 'react';
import Loading from './components/Loading';
import { getUserStorageComponent } from './utils/storage';
import { fetchUserInfo } from './services/user/actions';
import AuthInstance from './Auth/Auth';
import { getProfile } from './services/studentActions/profile/actions';
import { useRouter } from './hooks/router/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store/reducers';



const App = () => {

  const { history } = useRouter();
  const dispatch = useDispatch();
  const profile = useSelector((state: RootState) => state.profile)
  // Dispatch user profile
  const fetchProfileInfo = async () => {
    try {
      await dispatch(getProfile());
    } catch (error) {
    }
  }

  // Redirect user base on their profile info
  const checkRequiredProfileInfo = () => {
    if (profile && profile.country && profile.fullName && profile.email && profile.gender) {
      history.push('/student');
    } else {
      history.push('/signUpInfo');
    }
  }

  // Authenticate user if userInfo is not found
  const authenticateUser = async () => {
    try {
      await AuthInstance.isAuthenticated();
    } catch (error) {
      AuthInstance.login();
      return;
    }

    try {
      await fetchUserInfo();
      await fetchProfileInfo();
    } catch (error) {
    }
  }

  useEffect(() => {
    const checkUserAuthenticate = async () => {
      const userInfo = getUserStorageComponent('userinfo');
      if (userInfo) {
        if (profile && profile.id) {
          checkRequiredProfileInfo();
        } else {
          fetchProfileInfo();
        }
      } else {
        await authenticateUser()
      }
    }

    checkUserAuthenticate();
  }, [profile])

  return (
    <Loading pastDelay={true} className="loader-wrap big-loader" />
  );
}

export default App;